export function cls(className, mods = {}, additional = []) {
    const modsClasses = Object.entries(mods)
        .filter(([_, value]) => Boolean(value))
        .map(([className]) => className)
        .flat(1)
        .join(' ')
    return [className, modsClasses, ...additional.filter(Boolean)].join(' ')
}
